import { createElement, lazy } from 'react'
import { RouteObject } from 'react-router-dom'

import { DefaultMenuConfig, RouteConfig } from '../types/routing.types'
import { DEFAULT_ROUTES } from './default.routes'
import {
  CUSTOM_ROUTES_CONFIG,
  PUBLIC_ROUTES_CONFIG,
} from './route-configs.constants'

//TODO migrate reset password a previews view
const PUBLIC_ROUTES: Record<string, RouteConfig> = {
  LOGIN: {
    ...PUBLIC_ROUTES_CONFIG.LOGIN,
    element: createElement(
      lazy(() => import('@v2/domains/auth/views/Login.view')),
    ),
  },
  FORGOT_PASSWORD: {
    ...PUBLIC_ROUTES_CONFIG.FORGOT_PASSWORD,
    element: createElement(
      lazy(() => import('@v2/domains/auth/views/ForgotPassword.view')),
    ),
  },
  SELECT_ORGANIZATION: {
    ...PUBLIC_ROUTES_CONFIG.SELECT_ORGANIZATION,
    element: createElement(
      lazy(
        () => import('@v2/domains/organization/views/SelectOrganization.view'),
      ),
    ),
  },
  RESET_PASSWORD: {
    ...PUBLIC_ROUTES_CONFIG.RESET_PASSWORD,
    element: createElement(
      lazy(() => import('@v2/domains/auth/views/ResetPassword.view')),
    ),
  },
  SET_UP_PASSKEY: {
    ...PUBLIC_ROUTES_CONFIG.SET_UP_PASSKEY,
    element: createElement(
      lazy(() => import('@v2/domains/auth/views/SetUpPasskey.view')),
    ),
  },
  VERIFY_PASSKEY: {
    ...PUBLIC_ROUTES_CONFIG.VERIFY_PASSKEY,
    element: createElement(
      lazy(() => import('@v2/domains/auth/views/VerifyPasskey.view')),
    ),
  },
  EXPIRED_PASSKEY: {
    ...PUBLIC_ROUTES_CONFIG.EXPIRED_PASSKEY,
    element: createElement(
      lazy(() => import('@v2/domains/auth/views/ExpiredPasskey.view')),
    ),
  },
}

const CUSTOM_ROUTE: RouteConfig = {
  ...CUSTOM_ROUTES_CONFIG,
  element: createElement('div'),
}

const ALL_ROUTES: Record<string, RouteConfig> = {
  ...PUBLIC_ROUTES,
  ...DEFAULT_ROUTES,
  CUSTOM_PATH: CUSTOM_ROUTE,
}

export const getRoutes = (): Record<string, RouteConfig> => {
  const filteredRoutes: Record<string, RouteConfig> = {}

  Object.entries(PUBLIC_ROUTES).forEach(([key, route]) => {
    filteredRoutes[key] = route
  })

  filteredRoutes['CUSTOM_PATH'] = CUSTOM_ROUTE

  Object.entries(DEFAULT_ROUTES).forEach(([key, route]) => {
    filteredRoutes[key] = route
  })

  Object.entries(ALL_ROUTES)
    .filter(
      ([key, route]) =>
        !filteredRoutes[key] &&
        (!route.menuConfig?.platforms ||
          route.menuConfig.platforms.length === 0),
    )
    .forEach(([key, route]) => {
      filteredRoutes[key] = route
    })

  return filteredRoutes
}

export const getDefaultMenuItems = (): DefaultMenuConfig[] => {
  const platformRoutes = getRoutes()

  const menuItems = Object.values(platformRoutes)
    .filter((route) => route.showInMenu && route.menuConfig)
    .sort((a, b) => (a.menuConfig?.order || 0) - (b.menuConfig?.order || 0))
    .map((route) => ({
      id: route.key,
      path: route.path,
      title: route.label,
      icon: route.menuConfig?.icon,
      policy: route.policy,
    }))

  return menuItems
}

export const getRouteObjects = (): RouteObject[] => {
  const platformRoutes = getRoutes()

  const routeObjects = Object.values(platformRoutes)
    .filter((route) => route.key !== 'CUSTOM_PATH')
    .map((route) => ({
      path: route.path.startsWith('/') ? route.path.substring(1) : route.path,
      element: route.element,
    }))

  return routeObjects
}
